import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { FormControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { error } from 'console';

@Component({
  selector: 'app-logged-in-homepage',
  templateUrl: './logged-in-homepage.component.html',
  styleUrls: ['./logged-in-homepage.component.css']
})
export class LoggedInHomepageComponent implements OnInit {

  @ViewChild('dialogTemplate') dialogTemplate: TemplateRef<any>;

  loginID: any
  homepage: any
  userId: any
  seq1: any
  seq2: any
  seq3: any
  seq4: any
  userData: any = []
  carouselContent: any;
  userCreaticsCurrency: any
  userUpvoteBalance: any
  myControl = new FormControl();
  options: string[] = [];
  data = false;
  searchItem = true
  close = false
  isDataLoaded = false

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: true,
    dots: true,
    navSpeed: 200,
    navText: ['<', '>'],
    responsive: {
      0: {
        items: 1,
        slideBy: 1,
      },
      400: {
        items: 1,
        slideBy: 1
      },
      740: {
        items: 1,
        slideBy: 1
      },
      940: {
        items: 3,
        slideBy: 3
      }
    },
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    margin: 15,
    autoHeight: false,
    nav: false,
  }
  searchQuery: string = '';
  searchResults: any[] = [];

  constructor(
    private service: AdminService,
    private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private dialog: MatDialog) { this.loginID = route.snapshot.params.id; }

  ngOnInit(): void {
    this.service.getCreaticsHomepageLoggedIn().subscribe(data => {

      // if (data.hasNotification) {

      //   const dialogRef = this.dialog.open(this.dialogTemplate, {
      //     disableClose: true,
      //     data: {
      //         title: data.notification.title,
      //         description: data.notification.description,
      //         link: data.notification.link
      //     }
      //   });

      //   dialogRef.afterClosed().subscribe(result => {

      //   });

      // }

      this.userId = data.userId;
      if (this.userId == 0) {
        this.router.navigateByUrl(``)
      }

      if (this.userId != this.loginID) {
        window.location.href = '/userProfiles/' + this.loginID
      }


      this.homepage = data.loginHomePage

      this.seq1 = this.homepage.filter(obj => obj.sequence === 1);
      this.seq2 = this.homepage.filter(obj => obj.sequence === 2);
      this.seq3 = this.homepage.filter(obj => obj.sequence === 3);
      this.seq4 = this.homepage.filter(obj => obj.sequence === 4);
      this.carouselContent = data.carouselContent
      this.userCreaticsCurrency = data.userCreaticsCurrency
      this.userUpvoteBalance = data.userUpvoteBalance

      for (let contest of this.carouselContent) {
        contest.url = contest.contestActive ? "/contest/" + contest.contestId : "/contest";
      }
      console.log(this.carouselContent)

      this.userData = [
        {
          name: 'Fatoumata Sall',
          rank: 'Rookie',
          image: '/assets/images/1528314520_IMG_E1964.jpeg',
          url: '/userProfiles/13'
        },
        {
          name: 'Kimy Martinez',
          rank: 'Rookie',
          image: '/assets/images/1540247119_Kimy Martinez.jpg',
          url: '/userProfiles/18'
        },
        {
          name: 'Emmy Marzan',
          rank: 'Rookie',
          image: '/assets/images/1531460534_IMG_2783.jpg',
          url: '/userProfiles/2309'
        }
      ]

    });
  }


  search() {

    if (this.searchQuery.length < 3) {
      return;
    }

    this.service.fetchUser(this.searchQuery).subscribe(res => {
      this.searchResults = res;
      if (this.searchResults.length == 0) {
        this.data = false
      }
    },
      error => {
        console.log('Error fetching search results', error);
      }

    );

  }
  onSearchQueryChange(event: any) {
    if (this.searchQuery.length > 0) {
      this.close = true
      this.searchItem = false

      if (this.searchQuery.length < 3) {
        this.data = false

      }
      else {
        this.data = true
      }
      return;
    }

    else {
      this.close = false
      this.searchItem = true
      return;
    }

  }

  clear(){
    this.searchQuery = ''
    this.data =false
    this.close = false;
    this.searchItem= true
  }

}